import { ModalUpdateOrderMemoStoreInterface } from '@/store/ModalUpdateOrderMemoStore'
import { modalUpdateOrderMemoStore } from '@/utils/store-accessor'

export class ModalUpdateOrderMemoService {
  public open(params: ModalUpdateOrderMemoStoreInterface) {
    modalUpdateOrderMemoStore.open(params)
  }

  public close() {
    modalUpdateOrderMemoStore.close()
  }
}
